import { type Session } from "@supabase/supabase-js";
import { RouterProvider } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { LoginPage } from "@/components/auth/LoginPage";
import { SessionContext } from "@/components/layout/AdminShellContext";
import { FullPageLoading } from "@/components/ui";
import { supabase } from "@/lib/supabase";
import { router } from "@/routes";

export function App() {
  const [session, setSession] = useState<Session | null>(null);
  const [authLoading, setAuthLoading] = useState(Boolean(supabase));

  useEffect(() => {
    if (!supabase) return;
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setAuthLoading(false);
    });
    const { data } = supabase.auth.onAuthStateChange((_event, nextSession) => {
      setSession(nextSession);
    });
    return () => data.subscription.unsubscribe();
  }, []);

  if (authLoading) return <FullPageLoading label="Checking session" />;
  if (!session) return <LoginPage />;
  // The router mounts inside the auth gate, so no route ever renders without a
  // session and the tree needs no auth guard. `session` goes down a context
  // rather than the router's own: Supabase hands us a new object on every
  // token refresh, and rebuilding the router for that would reset navigation.
  return (
    <SessionContext.Provider value={session}>
      <RouterProvider router={router} />
    </SessionContext.Provider>
  );
}
